<template>
    <div id="tab-menu-visibility-container">
        <dx-tree-list
            id="treeMenu"
            :ref="treeListRefKey"
            :data-source="this.dataSource"
            :show-borders="true"
            :column-auto-width="true"
            :word-wrap-enabled="true"
            key-expr="id"
            parent-id-expr="parentId"
            @editor-preparing="onEditorPreparingPerm"
            :height="'60vh'"
        >
            <DxSearchPanel :visible="true" :width="250" :placeholder="$t('Shared.Search')" />
            <DxSorting mode="none" />
            <!-- or "multiple" | "none" -->
            <DxToolbar>
                <DxItem name="searchPanel" :width="250" />
            </DxToolbar>
            <DxEditing :allow-updating="true" mode="batch" />
            <DxColumn
                :width="300"
                data-field="caption"
                :caption="$t('userRoleDetails.accTo')"
                :allow-editing="false"
            />
            <DxColumn data-field="isvisible" headerCellTemplate="headerCellTemplate" />
            <template #headerCellTemplate="{ data }">
                <DxCheckBox
                    :value="false"
                    :text="$t('Shared.ViewAll')"
                    iconSize="16px"
                    @value-changed="onValueChangedCheck($event, data)"
                />
            </template>
        </dx-tree-list>
    </div>
</template>

<script>
import {
    DxTreeList,
    DxSearchPanel,
    DxSorting,
    DxToolbar,
    DxEditing,
    DxItem,
    DxColumn
} from 'devextreme-vue/tree-list';
import { DxCheckBox } from 'devextreme-vue/check-box';
import PatientPortalMenuService from '@/services/patientportalmenu.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';

const treeListRefKey = 'myTreeList';

export default {
    name: 'TabMenuVisibility',
    mixins: [ShowMessage, DBFunctions],
    components: {
        DxTreeList,
        DxSearchPanel,
        DxSorting,
        DxToolbar,
        DxEditing,
        DxItem,
        DxColumn,
        DxCheckBox
    },
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        },
        Name: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            dataSource: [],
            treeListRefKey
        };
    },
    computed: {
        treeList: function() {
            return this.$refs[treeListRefKey].instance;
        }
    },
    methods: {
        onEditorPreparingPerm(e) {
            e.editorOptions.onValueChanged = ev => this.onValueChanged(e, ev);
        },

        getMenuItemsChanges() {
            let changes = this.treeList.option('editing.changes');
            return changes.map(x => ({ id: x.key, isvisible: x.data.isvisible }));
        },

        markAsSaved() {
            this.treeList.saveEditData();
        },

        setCellValue(rowData, value) {
            rowData.isvisible = value;
            this.emitChanged();
        },

        onValueChangedCheck(e, d) {
            let changes = this.treeList.option('editing.changes');
            let dataField = d.column.dataField;

            this.treeList.forEachNode(node => {
                let curNode = changes.find(el => {
                    return node.key === el.key;
                });

                if (curNode) {
                    curNode.data[dataField] = e.value;
                } else {
                    changes.push({
                        key: node.key,
                        data: {
                            [dataField]: e.value
                        },
                        type: 'update'
                    });
                }
            });

            this.treeList.option('editing.changes', changes);
            this.emitChanged();
        },

        onValueChanged(e, ev) {
            e.setValue(ev.value);
            this.emitChanged();
        },

        async getDataSourceAsync() {
            await PatientPortalMenuService.getAll({})
                .then(response => {
                    if (response.data) {
                        this.dataSource = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        emitChanged() {
            var changed = {
                Changed: true,
                ComponentName: this.Name,
                Value: this.getMenuItemsChanges()
            };

            EventBus.$emit('onChanged', changed);
        }
    },
    async mounted() {
        await this.getDataSourceAsync();
    }
};
</script>
<style>
.dx-data-row .cell-provider-align {
    vertical-align: middle !important;
    padding-left: 10px !important;
}

.dx-data-row .headercell-view-padding {
    padding: 5px 5px 7px 5px !important;
}

.column-view-check .dx-treelist-rowsview .dx-treelist-empty-space {
    width: 0px !important;
}

.showNote {
    display: auto !important;
}

.dx-treelist .dx-freespace-row,
.dx-datagrid .dx-freespace-row {
    display: none !important;
}
</style>
